import { isMobileDevice } from '@/utils/util'
import VideoEnPlayer from './Player'
import {
  createLayerState,
  createMiniProgress,
  createReplay,
  createPlayerBottom,
  createPlayerPoster,
  createPlayerLoading,
  createPlayerNetwork,
  createPlayerError,
  createMiniClose,
  createMiniLayer,
  createPlayerBg
} from './layer/template'
import { query, addClass, removeClass } from './utils'

export default class VideoTemplate {
  player: VideoEnPlayer;
  // @ts-ignore
  $video: HTMLVideoElement;

  // @ts-ignore
  $error: HTMLElement;
  // @ts-ignore
  $errorBtn: HTMLElement;

  // @ts-ignore
  $network: HTMLElement;
  // @ts-ignore
  $networkBtn: HTMLElement;

  // @ts-ignore
  $cover: HTMLElement;
  // @ts-ignore
  $coverImage: HTMLElement;

  // @ts-ignore
  $layerState: HTMLElement;
  // @ts-ignore
  $layerStateBtn: HTMLElement;

  // @ts-ignore
  $loading: HTMLElement;

  // @ts-ignore
  $bottom: HTMLElement;
  // @ts-ignore
  $bottomState: HTMLElement;
  // @ts-ignore
  $bottomCurrent: HTMLElement;
  // @ts-ignore
  $bottomLoaded: HTMLElement;
  // @ts-ignore
  $bottomDuration: HTMLElement;
  // @ts-ignore
  $bottomFullScreen: HTMLElement;
  // @ts-ignore
  $bottomProgress: HTMLElement;
  // @ts-ignore
  $bottomBuffer: HTMLElement;
  // @ts-ignore
  $bottomProgressBlock: HTMLElement;
  // @ts-ignore
  $bottomProgressDrag: HTMLElement;

  // @ts-ignore
  $miniProgress: HTMLElement;
  // @ts-ignore
  $miniProgressLoaded: HTMLElement;
  // @ts-ignore
  $miniProgressBuffer: HTMLElement;

  // @ts-ignore
  $replay: HTMLElement;
  // @ts-ignore
  $replayBtn: HTMLElement;

  // @ts-ignore
  $miniLayer: HTMLElement;
  // @ts-ignore
  $miniLayerBtn: HTMLElement;

  // @ts-ignore
  $miniClose: HTMLElement;

  // @ts-ignore
  playerStateBg: HTMLElement;

  $container: VideoEnPlayer['container'];

  constructor(player: VideoEnPlayer) {
    this.player = player
    const { container } = player

    if (container instanceof Element) {
      this.$container = container as any
    } else {
      this.$container = query(container as any)
      console.log(this.$container, `No container element found by ${container}`)
    }

    this.query = this.query.bind(this)

    this.init()
  }

  static get html() {
    return `${createLayerState()}${createPlayerBottom()}${createPlayerNetwork()}${createPlayerPoster()}${createPlayerError()}${createPlayerLoading()}${createMiniProgress()}${createReplay()}${createMiniLayer()}${createMiniClose()}${createPlayerBg()}`
  }

  query(className: string) {
    return query(className, this.$container as any)
  }

  init() {
    // @ts-ignore
    document.querySelector('#hidden').innerHTML = VideoTemplate.html
    // @ts-ignore
    const childrenList = document.querySelector('#hidden').children
    for (let i = 0; i < childrenList.length; i += 1) {
      // @ts-ignore
      this.$container.append(childrenList[i].cloneNode(true))
    }
    // @ts-ignore
    document.querySelector('#hidden').innerHTML = ''

    this.$video = this.query('video') as HTMLVideoElement
    this.$error = this.query('.player-error')
    this.$errorBtn = this.query('.player-error .player-error-block')

    this.$network = this.query('.player-network')
    this.$networkBtn = this.query('.player-network .btn')

    this.$cover = this.query('.player-cover')
    this.$coverImage = this.query('.player-cover img')

    this.$layerState = this.query('.player-layer-state')
    this.$layerStateBtn = this.query('.player-layer-state img')

    this.$loading = this.query('.player-loading')

    this.$bottom = this.query('.player-bottom')
    this.$bottomState = this.query('.player-bottom .player-state')
    this.$bottomCurrent = this.query('.player-bottom .player-current')
    this.$bottomLoaded = this.query('.player-bottom .player-loaded')
    this.$bottomDuration = this.query('.player-bottom .player-duration')
    this.$bottomFullScreen = this.query('.player-bottom .player-full-screen')
    this.$bottomProgress = this.query('.player-bottom .player-progress')
    this.$bottomBuffer = this.query('.player-bottom .player-buffer')
    this.$bottomProgressBlock = this.query('.player-bottom .player-progress-block')
    this.$bottomProgressDrag = this.query('.player-bottom .player-loaded-drag')

    this.$miniProgress = this.query('.player-mini-progress')
    this.$miniProgressLoaded = this.query('.player-mini-progress .player-mini-loaded')
    this.$miniProgressBuffer = this.query('.player-mini-progress .player-mini-buffer')

    this.$replay = this.query('.player-replay')
    this.$replayBtn = this.query('.player-replay span')

    this.$miniLayer = this.query('.player-mini-layer')
    this.$miniLayerBtn = this.query('.player-mini-layer img')

    this.$miniClose = this.query('.player-mini-close')

    this.playerStateBg = this.query('.player-state-bg')

    // 此处初始化播放器效果
    this.$cover.style.width = `${this.player.options.width}px`
    this.$cover.style.height = `${this.player.options.height}px`

    this.$cover.style.backgroundImage = `url('${this.player.poster}')`

    if (this.player.originPoster) {
      this.$coverImage.style.width = `${this.player.options.width}px`
      this.$coverImage.style.height = `${this.player.options.height}px`
      this.$coverImage.setAttribute('src', this.player.poster)
    } else {
      this.$cover.style.backgroundSize = this.player.options.record.poster ? 'contain' : isMobileDevice() ? `3.52rem 1.6rem` : '132px 60px'
    }

    removeClass(this.$layerState, 'none')
    removeClass(this.$cover, 'none')
  }

  destroy() {
    addClass(this.$container, 'rmrb-player-destroy')
  }
}
